import { RentalFulfillment } from 'functions/src/types/firestore/Game/Collection/Item/RentalFulfillment';
import { Transaction } from 'functions/src/types/firestore/Game/Collection/Item/Transaction';
import { CryptoChain } from '../CryptoChain';

export class FulfillmentConverter {
  constructor(private readonly fulfillment: RentalFulfillment<Date>) {}
  public convertToTransaction(): Transaction<Date> {
    const { id, createdAt, renterAddress, lenderAddress, nft } =
      this.fulfillment;
    return {
      id,
      blockHash: '',
      blockNumber: 0,
      blockTimestamp: createdAt,
      fromAddress: renterAddress,
      toAddress: lenderAddress,
      amount: this.amount,
      contract: {
        address: nft.address,
        chainId: CryptoChain.MATIC.chainId,
        itemId: nft.identifier,
        type: 'ERC721',
      },
      collectionId: '',
      gameId: '',
      type: 'fulfillmentRental',
    };
  }

  private get amount(): string {
    return `${
      BigInt(this.fulfillment.priceHourly) * BigInt(this.fulfillment.hours)
    }`;
  }
}
